/**
 *  Function to generate HTML for Tooltip
 *
 * It use the same layout the default tooltip use but
 * support custom values and render it only if a custom
 * label is passed
 *
 * @param {String | Number} value Current value of the serie
 * @param {String} customLabel Custom string to show
 * @param {String | Number} customValue Value for the custom label
 * @returns
 */
export const generateCustomApexChartTooltip = (value, customLabel, customValue) => `  <div
class="apexcharts-tooltip-title"
style="font-family: Helvetica, Arial, sans-serif; font-size: 12px; z-index: 999"
>
203
</div>
<div
class="apexcharts-tooltip-series-group apexcharts-active"
style="order: 1; display: flex;"
>
<span
  class="apexcharts-tooltip-marker"
  style="background-color: rgba(0, 143, 251, 0.85);"
></span>
<div
  class="apexcharts-tooltip-text"
  style="font-family: Helvetica, Arial, sans-serif; font-size: 12px;"
>
  <div class="apexcharts-tooltip-y-group">
    <span class="apexcharts-tooltip-text-y-label">Cantidad: </span>
    <span class="apexcharts-tooltip-text-y-value">
      ${value}
    </span>
  </div>
  ${
    customLabel
      ? `<div class="apexcharts-tooltip-y-group">
    <span class="apexcharts-tooltip-text-y-label">${customLabel}: </span>
    <span class="apexcharts-tooltip-text-y-value">${customValue}</span>
    </div>`
      : ""
  }
    <div class="apexcharts-tooltip-goals-group">
    <span class="apexcharts-tooltip-text-goals-label"></span>
    <span class="apexcharts-tooltip-text-goals-value"></span>
  </div>
  <div class="apexcharts-tooltip-z-group">
    <span class="apexcharts-tooltip-text-z-label"></span>
    <span class="apexcharts-tooltip-text-z-value"></span>
  </div>
</div>
</div>
`;
